import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { UserService } from '../services/user.service';

export const superAdminExperimentGuard: CanActivateFn = async () => {
  const user$ = inject(UserService).user$;
  const router = inject(Router);
  const user = await firstValueFrom(user$);
  return user?.roles?.includes('super-admin') ? true : router.parseUrl('/admin/status');
};
